import { appEnv } from '@app/api/appEnv';
import { useLazyLogoutQuery, useLoginMutation } from '@auth/service/authLoginService';
import { useNavigate } from 'react-router-dom';
import { removeCookie, setCookie } from 'typescript-cookie';

const useAuthentication = () => {
    const navigate = useNavigate();
    const [executeLogin] = useLoginMutation();
    const [executeLogout] = useLazyLogoutQuery();
    const login = async (UserCode: string, password: string) => {
       await executeLogin( { UserCode, password } )
        .unwrap()
        .then((data) => {
            setCookie(appEnv.COOKIE_NAME, data.accessToken)
            navigate('/dashboard');
        })
    }

    const logout = async () => {
        await executeLogout();
        removeCookie(appEnv.COOKIE_NAME);
        removeCookie(appEnv.JWT_NAME);
        navigate('/login')
    };

    return {
        login,
        logout
    }
}

export default useAuthentication;